var _linearGradient, _radialGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _radialGradient2, _linearGradient6, _radialGradient3, _linearGradient7, _linearGradient8, _linearGradient9, _radialGradient4, _linearGradient10, _linearGradient11, _linearGradient12, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStrategy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "511pt",
    viewBox: "-69 0 511 511.99936",
    width: "511pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b395f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5234,
    stopColor: "#39385d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7119,
    stopColor: "#343356"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8463,
    stopColor: "#2a2b4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9541,
    stopColor: "#1b1f3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131830"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 215.222,
    cy: 459.1791,
    gradientTransform: "matrix(1.003922 0 0 .278287 -68.912726 327.359516)",
    gradientUnits: "userSpaceOnUse",
    r: 181.2964,
    xlinkHref: "#a"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#131830",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131830"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 181.9984029898,
    x2: 162.5307491346,
    xlinkHref: "#c",
    y1: 506.9404204732,
    y2: 404.039820964
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 118.1468555536,
    x2: 213.6858958212,
    y1: 443.8371964958,
    y2: 443.8371964958
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b395f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0633,
    stopColor: "#37355a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4033,
    stopColor: "#232543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7232,
    stopColor: "#171b35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131830"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 204.3346635678,
    x2: 57.0004763386,
    xlinkHref: "#c",
    y1: 454.2611194062,
    y2: 306.926932177
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 206.3573,
    cy: 382.5734,
    gradientTransform: "matrix(1.003922 0 0 .238431 -68.912726 292.870894)",
    gradientUnits: "userSpaceOnUse",
    r: 181.2966,
    xlinkHref: "#a"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 103.8092431184,
    x2: 121.0521054294,
    y1: 17.8658636574,
    y2: 52.3514878872
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b395f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3062,
    stopColor: "#38365b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5838,
    stopColor: "#2f2f50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8494,
    stopColor: "#1f223e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131830"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 37.7539865,
    cy: 59.79295932,
    gradientUnits: "userSpaceOnUse",
    r: 358.6681007818,
    xlinkHref: "#a"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 151.3776776756,
    x2: 280.2977267964,
    xlinkHref: "#c",
    y1: 269.2911011034,
    y2: 155.7345723096
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 70.3732193396,
    x2: 174.209574545,
    xlinkHref: "#c",
    y1: 340.4777042404,
    y2: 249.0155912148
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 203.7117299668,
    x2: 248.2093679104,
    xlinkHref: "#c",
    y1: 112.8569632974,
    y2: 90.6082447178
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    cx: 227.011354096,
    cy: 91.6269243712,
    gradientUnits: "userSpaceOnUse",
    r: 38.1360854062
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4873,
    stopColor: "#ffc636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6746,
    stopColor: "#ffc22f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8103,
    stopColor: "#ffbb23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9203,
    stopColor: "#ffb112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa700"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientUnits: "userSpaceOnUse",
    x1: 133.6022347436,
    x2: 193.814665322,
    y1: 462.708018722,
    y2: 462.708018722
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4286,
    stopColor: "#ffbb23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa700"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    gradientUnits: "userSpaceOnUse",
    x1: 193.5287483364,
    x2: 196.866086241,
    xlinkHref: "#c",
    y1: 447.0605892534,
    y2: 334.7041488184
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    gradientUnits: "userSpaceOnUse",
    x1: 230.7922247402,
    x2: 288.7846826,
    y1: 309.0380797508,
    y2: 387.2018403956
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3262,
    stopColor: "#fe4672"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5324,
    stopColor: "#fb3e6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7054,
    stopColor: "#f52f60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8591,
    stopColor: "#ee1a51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4003d"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m314.574219 466.550781c0-25.101562-69.230469-45.449219-154.628907-45.449219-85.398437 0-154.628906 20.347657-154.628906 45.449219 0 25.101563 69.230469 45.449219 154.628906 45.449219 85.398438 0 154.628907-20.347656 154.628907-45.449219zm0 0",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m314.574219 466.550781c0-25.101562-69.230469-45.449219-154.628907-45.449219-54.351562 0-102.148437 8.242188-129.722656 20.707032v2.566406c0 8.261719 3.46875 15.941406 9.257813 21.378906l39.523437 39.523438c23.546875 4.261718 51.265625 6.722656 80.941406 6.722656 85.398438 0 154.628907-20.347656 154.628907-45.449219zm0 0",
    fill: "url(#d)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m270.933594 471.726562c-71.40625 27.671876-150.574219 27.671876-221.980469 0-11.289063-4.375-18.730469-15.242187-18.730469-27.347656v-49.1875h259.445313v49.1875c0 12.105469-7.441407 22.972656-18.734375 27.347656zm0 0",
    fill: "url(#e)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m30.222656 424.550781 59.882813 59.882813c59.859375 13.976562 122.898437 9.742187 180.828125-12.707032 11.292968-4.375 18.734375-15.242187 18.734375-27.351562v-49.183594h-259.445313zm0 0",
    fill: "url(#f)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m314.574219 402.425781c0-21.5-69.230469-38.933593-154.628907-38.933593-85.398437 0-154.628906 17.433593-154.628906 38.933593 0 21.503907 69.230469 38.9375 154.628906 38.9375 85.398438 0 154.628907-17.433593 154.628907-38.9375zm0 0",
    fill: "url(#g)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m144.578125 12.648438c0-11.246094-13.597656-16.878907-21.550781-8.925782-16.859375 33.542969-50.230469 56.347656-50.230469 56.347656h104.230469l-16.050782-13.011718c-10.371093-8.414063-16.398437-21.054688-16.398437-34.410156zm0 0",
    fill: "url(#h)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m312.765625 137.636719-104.511719-84.738281c-10.371094-8.414063-16.398437-21.054688-16.398437-34.410157 0-11.246093-13.597657-16.878906-21.550781-8.925781-20.554688 20.554688-48.429688 32.101562-77.5 32.101562-90.828126 0-93.914063 187.824219-91.949219 257.289063.371093 13.128906 8.828125 24.578125 21.1875 29.035156 27.371093 9.871094 46.980469 37.277344 53.738281 47.859375 1.195312 1.871094 2.046875 3.914063 2.957031 5.9375 3.75 8.34375 34.949219 14.855469 72.878907 14.855469 38.195312 0 69.558593-6.601563 72.953124-15.027344.710938-1.765625 1.480469-3.5 2.453126-5.132812l26.613281-44.757813c8.804687-14.804687 2.53125-33.980468-13.324219-40.71875-46.585938-19.804687-76.828125-65.527344-76.828125-116.148437v-9.890625l.828125.824218c18.957031 18.960938 44.671875 29.613282 71.484375 29.613282h4.871094c7.910156 0 15.34375 3.351562 20.976562 8.90625 11.695313 11.542968 30.53125 11.496094 42.167969-.144532l11.804688-11.800781c15.472656-15.476562 14.148437-40.945312-2.851563-54.726562zm0 0",
    fill: "url(#i)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m240.3125 291.003906c-46.585938-19.804687-76.828125-65.527344-76.828125-116.148437v-9.640625c-2.667969-1.898438-11.414063-8.445313-19.273437-17.875-13.816407-16.585938-40.71875-9.171875-44.1875 12.132812-1.824219 11.191406-2.9375 24.917969-2.9375 41.765625 0 76.859375 75.300781 135.972657 143.75 152.011719l12.800781-21.527344c8.804687-14.804687 2.53125-33.980468-13.324219-40.71875zm0 0",
    fill: "url(#j)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m24.40625 273.382812c-8.175781 0-16.164062.789063-23.902344 2.277344.019532 8.691406.160156 16.550782.351563 23.292969.371093 13.128906 8.828125 24.578125 21.1875 29.035156 27.371093 9.871094 46.980469 37.277344 53.738281 47.859375 1.195312 1.871094 2.046875 3.914063 2.957031 5.9375 3.699219 8.230469 34.109375 14.671875 71.339844 14.847656-1.308594-68.292968-57.070313-123.25-125.671875-123.25zm0 0",
    fill: "url(#k)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m237.761719 128.4375c-4.300781 7.449219-21.339844 5.664062-38.054688-3.984375-16.714843-9.652344-26.777343-23.511719-22.476562-30.960937 4.300781-7.449219 21.335937-5.664063 38.050781 3.984374 16.714844 9.652344 26.78125 23.511719 22.480469 30.960938zm0 0",
    fill: "url(#l)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m216.761719 105.261719c6.5625 1.925781 17.398437 6.75 20.28125 18.019531.683593 2.667969-1.65625 5.109375-4.347657 4.527344-6.71875-1.453125-18.039062-5.753906-20.570312-18.324219-.542969-2.699219 2-4.996094 4.636719-4.222656zm0 0",
    fill: "url(#m)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m82.285156 470.574219c50.746094 14.527343 104.570313 14.527343 155.320313 0 2.433593-.699219 4.097656-2.945313 4.097656-5.476563v-15.441406c0-3.585938-3.28125-6.3125-6.796875-5.59375-24.527344 4.992188-49.742188 5.117188-74.960938 5.117188s-50.433593-.125-74.960937-5.117188c-3.515625-.71875-6.796875 2.007812-6.796875 5.59375v15.441406c0 2.53125 1.664062 4.777344 4.097656 5.476563zm0 0",
    fill: "url(#n)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m314.574219 466.550781c0-9.125-9.15625-17.621093-24.90625-24.742187v-18.1875c15.75-6.097656 24.90625-13.375 24.90625-21.195313 0-14.925781-33.363281-27.886719-82.332031-34.421875l-19.707032 15.429688c-8.097656 6.207031-19.128906 6.414062-27.453125.519531l-94.621093-67.023437c-4.261719-3.015626-10.160157-2.011719-13.179688 2.25-3.019531 4.261718-2.011719 10.164062 2.25 13.183593l.199219.140625 127.082031 127.140625.199219.140625c.617187.910156 1.398437 1.734375 2.347656 2.40625l53.894531 38.171875c31.5-8.316406 51.320313-20.386719 51.320313-33.8125zm0 0",
    fill: "url(#o)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m353.925781 263.304688-23.136719 5.515624c-11.574218 2.757813-16.195312 16.734376-8.554687 25.851563l1.453125 1.730469-111.152344 87.03125c-8.097656 6.207031-19.128906 6.414062-27.457031.519531l-94.617187-67.023437c-4.261719-3.015626-10.164063-2.011719-13.179688 2.25-3.019531 4.261718-2.011719 10.164062 2.25 13.183593l94.617188 67.019531c7.328124 5.191407 15.8125 7.777344 24.292968 7.777344 9.027344 0 18.050782-2.929687 25.675782-8.777344l111.726562-87.480468.058594.070312c7.644531 9.117188 22.210937 7.003906 26.949218-3.910156l9.46875-21.816406c5.25-12.097656-5.566406-25-18.394531-21.941406zm0 0",
    fill: "url(#p)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStrategy);
export default __webpack_public_path__ + "static/media/icon-strategy.edf0db8a50535b484f0b75cb1efccb7b.svg";
export { ForwardRef as ReactComponent };